import React, {useEffect, useState} from 'react';
import {FormattedMessage, useIntl} from "react-intl";
import {HttpStatus} from "../../../modules/common/enums/HttpStatus";
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    List,
    ListItem, ListItemSecondaryAction,
    ListItemText,
    Tab,
    Tabs
} from "@mui/material";
import CancelButton from "../../../components/buttons/CancelButton";
import dayjs from "dayjs";
import {Formats} from "../../../constants/Formats";
import {RequestTimeSettingApi} from "../../../modules/vms/api/RequestTimeSettingApi";
import {RequestTimeSettingDto} from "../../../modules/vms/dto/RequestTimeSettingDto";
import StringUtils from "../../../utils/StringUtils";
import {RequestTimeSettingStatus} from "../../../modules/vms/enums/RequestTimeSettingStatus";

export type ArriveTimeSelectDialogProps = {
    onClose: () => void;
    onSelect: (date: string, startTime: string, endTime: string) => void;
    open: boolean;
    classify: string
};

const RequestArriveTimeSelectableDialog: React.FC<ArriveTimeSelectDialogProps> = (props) => {
    const intl = useIntl();

    // 日期列表
    const [dateList, setDateList] = useState(new Array<string>());
    const [selectedDate, setSelectedDate] = useState<string>('');

    // 时间列表
    const [requestTimeSettingList, setRequestTimeSettingList] = useState(new Array<RequestTimeSettingDto>());

    useEffect(() => {
        if (props.open) {
            const dateList = new Array<string>;
            for (let i = 0; i < 5; i++) {
                dateList.push(dayjs().add(i, 'days').format(Formats.DATE_SIMPLE));
            }
            // 设定第一天为首选日期
            setSelectedDate(dateList[0]);
            setDateList(dateList);

            // 获取时间区分列表
            fetchRequestTimeActualList(dateList[0], props.classify);
        } else {
            setDateList([]);
            setSelectedDate('');
            setRequestTimeSettingList([]);
        }
    }, [props.open]);

    const fetchRequestTimeActualList = async (arriveDate: string, classify: string) => {
        const responseResult = await RequestTimeSettingApi.getRequestTimeActualList(arriveDate, classify);
        if (responseResult && responseResult.status === HttpStatus.SUCCESS) {
            setRequestTimeSettingList(responseResult.data);
        }
    };

    const handleClose = () => {
        props.onClose();
    };

    const handleSelectBookingTime = (bookingTime: RequestTimeSettingDto) => {
        props.onSelect(selectedDate, bookingTime.startTime, bookingTime.endTime);
        props.onClose();
    };

    return (
        <Dialog open={props.open} onClose={handleClose} fullWidth={true}>
            <DialogTitle>
                <FormattedMessage id="VMS_VISIT_REQUEST_ARRIVE_TIME_SELECT"/>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Tabs value={selectedDate}
                              orientation="vertical"
                              variant="scrollable"
                              onChange={(e, value) => setSelectedDate(value)}>
                            {
                                dateList.map((item, index) => {
                                    return (
                                        <Tab key={index} value={item} label={StringUtils.formatDate(item)}/>
                                    )
                                })
                            }
                        </Tabs>
                    </Grid>
                    <Grid item xs={8}>
                        {
                            <List dense>
                                {requestTimeSettingList.map((item, index) => {
                                    let message = intl.formatMessage({id: 'VMS_REQUEST_TIME_SETTING_DISABLE'});
                                    if (item.status === RequestTimeSettingStatus.Enum.Enable) {
                                        if (item.actualSum < item.limitSum) {
                                            message = intl.formatMessage({id: 'VMS_REQUEST_TIME_SETTING_ENABLE'}) + ":" + (item.limitSum - item.actualSum).toString();
                                        } else {
                                            message = intl.formatMessage({id: 'VMS_REQUEST_TIME_SETTING_FULL'});
                                        }
                                    }
                                    return (
                                        <ListItem key={index} button
                                                  onClick={() => handleSelectBookingTime(item)}>
                                            <ListItemText
                                                primary={StringUtils.formatTime(item.startTime) + " ~ " + StringUtils.formatTime(item.endTime)}/>
                                            <ListItemSecondaryAction>
                                                <Button size={'small'}
                                                        disabled={item.status === RequestTimeSettingStatus.Enum.Disable ||
                                                        item.actualSum >= item.limitSum} variant="text"
                                                        onClick={(event) => handleSelectBookingTime(item)}>{message}</Button>
                                            </ListItemSecondaryAction>
                                        </ListItem>
                                    );
                                })}
                            </List>
                        }
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions>
                <CancelButton onClick={handleClose}/>
            </DialogActions>
        </Dialog>
    );
};

export default RequestArriveTimeSelectableDialog;
